import { Box, Button, Typography } from "@mui/joy";
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import DsfAdminAdd from "./dsf-admin-Add";
import { dsfAdminRemove, dsfAdminUpdate } from "../../service/dsfAdminService";
import { RouteComponentProps } from "../../models/RouteComponent";
import { resetPassword } from "../../service/api-service";

export default function DsfAdminView(props: RouteComponentProps) {

  const [selectedAdmin, setSelectedAdmin] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'surname': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'mobile': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'email': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'active': { value: true, matchMode: FilterMatchMode.CONTAINS },
  }

  const deleteButton = (row: any) => {
    dsfAdminRemove(selectedAdmin.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedAdmin(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    setSelectedAdmin(row.value);
    // setVisible(true);
    DialogSetVisible(row);
  }

  const contextItemSelected = (row: any) => {
    setSelectedAdmin(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await dsfAdminRemove(selectedAdmin.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'DSF Admin Deleted Successfully', life: 3000 });
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }


  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await dsfAdminUpdate(selectedAdmin.id, { "active": status });
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Admin Activated Successfully' : 'Admin Deactivated Successfully', life: 3000 });
  }

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  }

  const resetPasswordFunc = (row: any) => {
    props.setGlobalLoader(true);
    resetPassword(selectedAdmin.id).then((client) =>{
      props.setGlobalLoader(false);
      setReload(!reload);
      toast.current.show({ severity: 'success', summary: 'Password Reset Successfully', life: 3000 });
    });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate admin?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate admin?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }

  const contextItems = () => {
    let objArray = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: DialogSetVisible }
    ];
    if (selectedAdmin?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'surname',
      header: 'Surname',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'mobile',
      header: 'Mobile',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'email',
      header: 'Email address',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          DSF Admin
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url="admin" columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedAdmin?.id ? 'Update DSF Admin' : 'Add DSF Admin'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <DsfAdminAdd setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedAdmin?.id} admin={selectedAdmin} setVisible={setVisible} toast={toast} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}